module.exports = __webpack_public_path__ + "static/media/reportztms.d5e5bab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/reportztms.png
// module id = 443
// module chunks = 0